import getPostTypeStaticPaths from '@/functions/wordpress/postTypes/getPostTypeStaticPaths'

import getPostTypeStaticProps from '@/functions/wordpress/postTypes/getPostTypeStaticProps'

import Layout from '@/components/common/Layout'

import Teaser from '@/components/blocks/custom/Teaser'

import Blocks from '@/components/molecules/Blocks'

import {formatDate} from '@/functions/utils'

import Share from '@/components/molecules/Share/Share'

import RelatedPosts from '@/components/blocks/custom/RelatedPosts'

const postType = 'post'

export default function Post({post}) {
  return (
    <Layout removeMarginTopFooter seo={{...post?.seo}}>
      <article className="innerWrap">
        <Teaser
          block={{
            title: post.title,
            image: post?.featuredImage?.node,
            label: 'Blog',
            titleLabel: formatDate(post.date)
          }}
        />

        <Blocks blocks={post?.blocks} />
        <Share />
      </article>
      <RelatedPosts
        block={{
          posts: post?.relatedPosts,
          title: post?.language.code === 'DE' ? 'Weitere News' : 'More News'
        }}
      />
    </Layout>
  )
}

export async function getStaticPaths() {
  return await getPostTypeStaticPaths(postType, false)
}

export async function getStaticProps({params, locale, preview, previewData}) {
  return getPostTypeStaticProps(
    {...params, locale},
    postType,
    preview,
    previewData
  )
}
